import { apiSlice } from "@/shared/api/api-slice"

export type OnboardingFirstContactButton = "setup_moderation" | "try_ai_shield"

export type OnboardingWebappEvent = "feature_flow_opened" | "screen_viewed" | "action_taken" | "paywall_reached"

export interface ReportFirstContactEventArgs {
  button: OnboardingFirstContactButton
  event?: OnboardingWebappEvent
  chatId?: number | null
  correlationId?: string | null
  screen?: string | null
  action?: string | null
}

export type ShowcaseEvent =
  | "shown"
  | "slide_viewed"
  | "completed"
  | "skipped"
  | "add_group_tapped"
  | "look_around_tapped"

export interface ReportShowcaseEventArgs {
  event: ShowcaseEvent
  slideId?: string | null
  correlationId?: string | null
}

export const onboardingApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    reportShowcaseEvent: builder.mutation<undefined, ReportShowcaseEventArgs>({
      query: ({ event, slideId, correlationId }) => ({
        url: `/api/v1/onboarding/showcase/event`,
        method: "POST",
        body: {
          event,
          slide_id: slideId,
          correlation_id: correlationId
        }
      })
    }),
    reportFirstContactEvent: builder.mutation<undefined, ReportFirstContactEventArgs>({
      query: ({ button, event, chatId, correlationId, screen, action }) => ({
        url: `/api/v1/onboarding/first-contact/event`,
        method: "POST",
        body: {
          button,
          event,
          chat_id: chatId,
          correlation_id: correlationId,
          screen,
          action
        }
      })
    })
  })
})

export const { useReportFirstContactEventMutation, useReportShowcaseEventMutation } = onboardingApi
